import React, { useEffect, useState, Fragment, Component, useRef } from 'react'
import { accessRole } from "../../../../helpers/access_role"
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button, Label,
    Fieldset, Legend
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { FileInput, generateFormData } from '../../../../helpers/ui/FileInput'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"
import Select from "react-select"

import { Link, useHistory, Redirect } from "react-router-dom"
import apiResponse from '../../../../services/apiResponse'

import CreateModal from './Components/CreateModal'
import TableComponent from './Components/TableComponent'

import IndexBloc from '../Index/Blocs/IndexBloc_'
import CreateBloc from './Blocs/CreateBloc'

const reformatDate = (date) => {
    const months = [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember",
    ];
    const d = new Date(date);
    let dt = d.getDate()
    if (dt < 10) {
        dt = '0'+dt
    }

    if (date) {
        return dt + " " + months[d.getMonth()] + " " + d.getFullYear();
    }

    return '-'
};



class CreateView extends Component {

    createBloc = new CreateBloc()
    indexBloc = new IndexBloc()
    constructor(props) {
        super(props)
        this.inactiveRef = React.createRef()
        this.state = {
            modal: false,
            uuid: this.props.uuid ? this.props.uuid : '',
            detailUuid: null,
            detail: null
        }
    }

    reloadInactiveRef = () => this.inactiveRef.current.setTokenAPI()

    setUuid = value => {
        this.setState({ uuid: value })
    }

    setDetailUuid = value => {
        this.setState({ detailUuid: value })
    }

    toggle = () => {
        this.setState({ modal: !this.state.modal })
    }

    handlerOnSubmit = () => {
        this.setState({ confirm: true })
    }

    submitData = async () => {
        await this.createBloc.fetchSubmit({ uuid: this.state.uuid })
    }

    loadDetail = async () => {
        await this.indexBloc.fetchDetail({ uuid: this.state.uuid })
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    componentDidMount() {

        this.loadDetail()

        this.createBloc.submitChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.indexBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        detail: result.data.response
                    })
                    break;
                default:
                    break;
            }
        })

    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.modal != this.state.modal) {
            if (!this.state.modal) {
                this.setState({ detailUuid: null })
            }
        }
        if (prevState.detailUuid != this.state.detailUuid) {
            if (this.state.detailUuid) {
                this.setState({ modal: true })
            }
        }
    }

    componentWillUnmount() {
        this.createBloc.submitChannel?.unsubscribe()
        this.indexBloc.detailChannel?.unsubscribe()
    }

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Card>
                        <CardBody>
                            <div className="float-end">
                                <Link to={`/kepegawaian/mutasi_pegawai.html`}>
                                    <Button outline color="primary"><i className="uil uil-backward"></i> Kembali</Button>
                                </Link> {'  '}
                                {
                                    (accessRole('approve')) &&
                                        <Button color="primary" onClick={() => this.toggle()}>Tambah Pegawai</Button>
                                }
                                {'  '}
                                {
                                    (accessRole('approve')) &&
                                        <Button color="success" onClick={() => this.handlerOnSubmit()}>Submit</Button>
                                }
                            </div>
                            <CardTitle>Tambah Mutasi Pegawai</CardTitle>
                            {
                                this.state.detail &&
                                <CardSubtitle>Periode : {reformatDate(this.state.detail?.employee_transfer_date)}</CardSubtitle>
                            }
                            <hr/>
                            <TableComponent uuid={this.state.uuid} ref={this.inactiveRef} handleInactiveSuccess={this.reloadInactiveRef} setDetailUuid={value => this.setDetailUuid(value)} />
                        </CardBody>
                    </Card>
                </Container> 

                <CreateModal modal={this.state.modal} toggle={() => this.toggle()} uuid={this.state.uuid} setUuid={value => this.setUuid(value)} handleReload={this.reloadInactiveRef} detailUuid={this.state.detailUuid} />

                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin data tersebut sudah benar?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to={`/kepegawaian/mutasi_pegawai.html`}/>
                : null }
            </Fragment>
        )
    }
}

export default CreateView